var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    {
      directives: [{ name: "sticky", rawName: "v-sticky" }],
      staticClass: "sub-navigation"
    },
    [
      _c(
        "ul",
        [
          _vm._l(_vm.items, function(item) {
            return _c(
              "li",
              { key: item.key, class: { active: _vm.page === item.key } },
              [
                item.url
                  ? _c(
                      "a",
                      { attrs: { href: item.url } },
                      [
                        _c("Icon", { attrs: { icon: item.icon } }),
                        _vm._v(" "),
                        _c("span", { staticClass: "text" }, [
                          _vm._v(_vm._s(item.text))
                        ])
                      ],
                      1
                    )
                  : _c(
                      "span",
                      [
                        _c("Icon", { attrs: { icon: item.icon } }),
                        _vm._v(" "),
                        _c("span", { staticClass: "text" }, [
                          _vm._v(_vm._s(item.text))
                        ])
                      ],
                      1
                    ),
                _vm._v(" "),
                _vm.customer && item.key === "job-profiles"
                  ? [
                      _vm._l(_vm.customer.jobProfiles, function(jobProfile) {
                        return _c(
                          "a",
                          {
                            key: jobProfile.id,
                            class: [
                              "sub-link",
                              {
                                "sub-link-active":
                                  _vm.subLinkActiveKey === jobProfile.id
                              }
                            ],
                            attrs: {
                              href: "/kundenbereich/jobs/" + jobProfile.id
                            }
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t" +
                                _vm._s(jobProfile.name) +
                                "\n\t\t\t\t\t"
                            ),
                            jobProfile.newMessagesCount > 0
                              ? _c("span", { staticClass: "highlight" })
                              : _vm._e()
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          class: [
                            "sub-link",
                            {
                              "sub-link-active":
                                _vm.subLinkActiveKey === "addJobProfile"
                            }
                          ],
                          attrs: { href: "/kundenbereich/jobs/anlegen" }
                        },
                        [
                          _c("Icon", { attrs: { icon: "plus" } }),
                          _vm._v("\n\t\t\t\t\tNeuen Job anlegen\n\t\t\t\t")
                        ],
                        1
                      )
                    ]
                  : _vm._e()
              ],
              2
            )
          }),
          _vm._v(" "),
          _vm.shouldShow("logout")
            ? _c("li", [
                _c(
                  "a",
                  {
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.logout.apply(null, arguments)
                      }
                    }
                  },
                  [
                    _c("Icon", { attrs: { icon: "logout" } }),
                    _vm._v(" "),
                    _c("span", { staticClass: "text" }, [_vm._v("Abmelden")])
                  ],
                  1
                )
              ])
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _vm.customer &&
      _vm.page === "job-profiles" &&
      _vm.shouldShow("job-profiles")
        ? _c("div", { staticClass: "sub-navigation--job-profiles" }, [
            _c(
              "div",
              [
                _c("Select", {
                  attrs: {
                    options: _vm.jobProfileOptions,
                    value:
                      _vm.subLinkActiveKey === "addJobProfile"
                        ? undefined
                        : _vm.subLinkActiveKey
                  },
                  on: { change: _vm.jobProfileChanged }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("div", [
              _c(
                "a",
                { attrs: { href: "/kundenbereich/jobs/anlegen" } },
                [_c("Icon", { attrs: { icon: "plus" } })],
                1
              )
            ])
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }